exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".scope-written{margin:30px;padding:10px 30px}.scope-written .pick-exam-time .color-gray,.scope-written .pick-exam-time .time-dot .el-form-item__label{color:#999}.scope-written .pick-exam-time .end-time-holder{display:inline-block;width:50px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bb62d35e","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/written/writtenArrangement.vue
// module id = 931
// module chunks = 23